// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".remove-attribute_b9bd7075{color:#b32700}.remove-attribute_b9bd7075:hover{color:#b32700}", ""]);
// Exports
export var removeAttribute = "remove-attribute_b9bd7075";
export default ___CSS_LOADER_EXPORT___;
